import { useCallback, useState } from 'react'

const TRANSITION_TIMEOUT = 705

/**
 * Custom hook for managing chart transition states
 * Provides consistent transition timing across all chart components
 */
export function useChartTransition() {
  const [isTransitioning, setIsTransitioning] = useState<boolean>(false)

  const startTransition = useCallback(() => {
    setIsTransitioning(true)
    setTimeout(() => {
      setIsTransitioning(false)
    }, TRANSITION_TIMEOUT)
  }, [])

  return {
    isTransitioning,
    startTransition,
  }
}
